import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import SmoothScroll from "@/components/SmoothScroll";
import { Nav } from "@/components/Nav";
import { CartDrawer } from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Auth from "@/pages/Auth";
import Orders from "@/pages/Orders";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <SmoothScroll>
            <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#121212", border: "1px solid #222", color: "#F4F1EC", fontFamily: "JetBrains Mono, monospace", fontSize: "13px" } }} />
            <Nav />
            <CartDrawer />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
            </Routes>
          </SmoothScroll>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
